import { useCallback, useEffect, useRef } from "react";

import { globalEvents } from "../helpers/GlobalEvents";

type GenericHandlerFn = (...args: any[]) => void;

export const useGlobalEvent = (event: string, handler: GenericHandlerFn) => {
	const handlerFn = useRef<GenericHandlerFn>(handler);
	const callback = useCallback((...args: any[]) => {
		return handlerFn.current(...args);
	}, []);

	useEffect(() => {
		handlerFn.current = handler;
	}, [handler]);

	useEffect(() => {
		globalEvents.on(event, callback);

		return () => {
			globalEvents.off(event, callback);
		};
	}, []);
};
